import React, { useState, useRef } from "react";
import moment from "jalali-moment";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// import JS files
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import MuiButton from "../../../shares/MuiButton";

const AdminPrintGeneralOrderByCustomer = () => {
  const navigate = useNavigate();

  const [currentOerdersList, setCurrentOerdersList] = useState({ results: [] });
  const { unique_id, store_name, date, city } = useParams();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15000,
    count: 0,
    next: null,
    previous: null,
  });
  const adminGetCustomerCurrentOrderApi = useFetch({
    method: "get",
    pagination: pagination,

    url: `Order_Service/admin_get_onprogress_order`,
    params: {
      unique_id: unique_id == "null" ? null : fixNumbers(unique_id),
      date: date == "null" ? null : date,
      store_name: store_name == "null" ? null : store_name,
      city: city == "null" ? null : city,
    },
    trigger: true,
    setter: setCurrentOerdersList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const componentRef = useRef();
  const closeTab = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };
  return (
    <>
      <div className="my-4">
        <div className="flex justify-between items-center mx-8 mb-4">
          <span className="text-sm">برای دانلود فایل PDF کلیک کنید.</span>
          <div className="flex">
            <ReactToPrint
              trigger={() => {
                return (
                  <MuiButton
                    variant="contained"
                    color="primary"
                    text="دانلود فایل PDF"
                    size="small"
                    //    icon={<ModeEditIcon />}
                  />
                );
              }}
              content={() => componentRef.current}
            />
            <div className="mr-4">
              <MuiButton
                onClick={() => closeTab()}
                variant="outlined"
                color="secondary"
                text="بازگشت"
                size="small"
                icon={<ArrowBackIcon />}
              />
            </div>
          </div>
        </div>
        <div
          className="printTable"
          ref={componentRef}
          style={{ direction: "rtl" }}
        >
          <div className=" bg-myblue-100 px-8 py-4 text-center">
            <span className="font-bold text-yellow-200 text-lg">
              فروشگاه زرسان
            </span>
          </div>
          <div className="text-center mt-8">
            <span className="font-bold">سفارش های جاری براساس مشتری</span>
          </div>
          <div className="border rounded-md mt-4 overflow-hidden mx-2">
            <div className="flex justify-between">
              <div className="basis-1/2  text-center py-1 ">
                <span className="text-sm text-myblue-100">ردیف</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">سند</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">مشتری</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تاریخ ثبت سفارش</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">وزن</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> وضعیت</span>
              </div>
            </div>
          </div>

          {currentOerdersList.results.map((item, index) => {
            return [
              <>
                <div className="border rounded-md overflow-hidden mx-2">
                  <div className="flex justify-between">
                    <div className="basis-1/2  text-center py-1  border-r">
                      <span className="text-sm text-myblue-100">
                        {index + 1}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.unique_id}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.name}
                      </span>
                    </div>

                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {moment(item.created_at, "YYYY/MM/DD")
                          .locale("fa")
                          .format("YYYY/MM/DD")}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.total}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.factor_status}
                      </span>
                    </div>
                  </div>
                </div>
                {index == 21 ? <div className="break"></div> : undefined}
              </>,
            ];
          })}
        </div>
      </div>
    </>
  );
};

export default AdminPrintGeneralOrderByCustomer;
